export * from './getColor';
